/**
 * 网友评论楼层公共组件（2026-10-23 茄子令「抽公共组件复用」）：一条评论 =
 * 圆头像 + 正文区（右浮点赞〔数在左、图标在右〕+ 昵称 + 文本）+ 头像右起的分隔虚线。
 *
 * 三处消费：MediaPanel 热议帖楼层（原 hp-cmt）、微博热评（原 wb-cmt）、
 * ReviewPanel 网友评价（原 review-post，2026-10-23 令「与媒体弹窗评论区对齐」）。
 * 类名只有一套（.cmt-*），各宿主⛔ 再自建评论样式；样式细节改动只动 ui.css 的 .cmt 块。
 *
 * 点赞数/头像色都是**现场做种**的展示读数（同 MediaPanel BUZZ 口径：不落盘、不进结算），
 * hash 与 avatarColor 从两个面板的重复实现收编于此，三处共用同一份。
 */
import { createDiv, createSpan, setPlotText } from './ui';
import { icon, IconName } from './icons';

/** 字符串 hash（h=31 折叠族；原 MediaPanel/ReviewPanel 各持一份，收编共用） */
export function stringHash(seed: string): number {
    let h = 0;
    for (const ch of seed) h = (h * 31 + ch.charCodeAt(0)) % 1000003;
    return h;
}

/** 头像底色：由字符串 hash 出色相。⚠️ 昵称全 momo ⇒ 拿**正文**做种子（拿名字算会一屏同色） */
export function avatarColor(seed: string): string {
    return `hsl(${stringHash(seed) % 360}, 22%, 62%)`;
}

export interface CommentFloorOpts {
    /** 昵称行 */
    name: string;
    /** 评论文本（走 plot 富文本，与媒体弹窗评论同一条管线） */
    text: string;
    /** 头像字（网名首字 / 兜底字） */
    avatarText?: string;
    /** 头像底色 CSS 值（调用方用 avatarColor(正文) 算；缺省按 text 现算） */
    avatarBg?: string;
    /** 右浮赞数（已格式化的字符串，如 '2.5万'）；不传＝不渲染赞行（空态场景） */
    likes?: string;
}

/** 拼一条评论楼层。同一列表里连着 append，分隔虚线由 .cmt::after 出、末条自动去线 */
export function createCommentFloor(opts: CommentFloorOpts): HTMLElement {
    const floor = createDiv('cmt');
    const avatar = createDiv('cmt-avatar');
    avatar.style.background = opts.avatarBg ?? avatarColor(opts.text);
    avatar.textContent = opts.avatarText ?? opts.name.slice(0, 1);
    floor.appendChild(avatar);

    // 赞右浮在正文区里（先于文本进 DOM）：长评论过了赞的高度就延伸到赞下方，
    // ⛔ 用「正文列 + 右侧赞列」的 flex 三列布局（2026-10-23 茄子令：评论没到点赞下面就换行了）
    const body = createDiv('cmt-body');
    if (opts.likes !== undefined) {
        const likeRow = createSpan('cmt-likes');
        likeRow.appendChild(createSpan(undefined, opts.likes));
        likeRow.appendChild(icon('like' as IconName));
        body.appendChild(likeRow);
    }
    body.appendChild(createDiv('cmt-name', [opts.name]));
    body.appendChild(setPlotText(createDiv('cmt-text'), opts.text));
    floor.appendChild(body);
    return floor;
}
